<div class="container">
  <div class="title clickable" (click)="goHome()">
    <div class="logo-container"><img src="assets/images/logo.png" alt="NRG Metrics" class="logo" /></div>
    @if (environmentLabel) {
      <span class="env-badge">{{ environmentLabel }}</span>
    }
  </div>
  <div class="user-actions">
    @if (username()) {
      <div class="username">Hello, <strong>{{ username() }}</strong></div>
    }
    @if (variant === 'admin') {
      <button class="notification-icon-button" mat-icon-button [matMenuTriggerFor]="notificationMenu" (menuOpened)="onNotificationMenuOpened()" [attr.aria-label]="unreadCount() > 0 ? 'Notifications, ' + unreadCount() + ' unread' : 'Notifications'">
        <mat-icon class="notification-icon"
          [matBadge]="unreadCount()"
          [matBadgeHidden]="unreadCount() === 0"
          matBadgeColor="primary"
          aria-hidden="false">notifications_none</mat-icon>
      </button>
      <mat-menu class="notification-menu" #notificationMenu="matMenu">
        <app-notifications-menu></app-notifications-menu>
      </mat-menu>
    }
    <div class="user-button" [matMenuTriggerFor]="userMenu" [matTooltip]="userTooltip()" matTooltipClass="multiline-tooltip">
      <mat-icon class="user-icon large-icon">account_circle</mat-icon>
    </div>
    <mat-menu class="user-menu" #userMenu="matMenu">
      <app-profile-menu [hideMessages]="variant === 'portal'"></app-profile-menu>
    </mat-menu>
  </div>
</div>
